<template>
  <div id="app" class="h-100">
      <!--<HeaderNav/>-->
      <router-view></router-view>
  </div>
</template>

<script>
    //import HeaderNav from './components/HeaderNav.vue'

export default {
  name: 'App',
    components: {
        //HeaderNav
    }
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap" rel="stylesheet');

    html, body {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;

        background: linear-gradient(140deg, #e5e5e5, #f2f2f2);

    }

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0px;
}

html, body
{
  height: 100%;
  font-size: 0.95rem;
}

.breadcrumb-item {
    font-size: small;
}

.nav-tabs {
    font-size: small;
}

.breadcrumb {
  background: linear-gradient(#f4f5f8,#f1f3f6);
}
.sidenav {
  background: linear-gradient(#f4f5f8,#f1f3f6);
}
.bg-dark {
  background: linear-gradient(170deg, #343a40,#484d53);
}

.card-body {
  padding: 1rem;
}

.vgt-table th {
  padding: 0.6em;
}

.vgt-table th.vgt-row-header {
  background: linear-gradient(#f4f5f8,#f1f3f6);
}

table.vgt-table {
  font-size: 14px;
}

.vgt-wrap__footer {
  padding: 0.7em;
}

.vgt-wrap__footer {
  font-size: 1.0rem;
}
.vgt-wrap__footer .footer__row-count__label {
  font-size: 1.0rem;
}
.vgt-wrap__footer .footer__row-count__select {
  font-size: 1.0rem;
}
.vgt-wrap__footer .footer__navigation {
  font-size: 1.0rem;
}

.card-header {
  padding: .5rem 1rem;
}

.btn-primary {
  color: #fff;
  background-color: #1a96d3;
  border-color: #1a96d3;
}
.badge-primary {
  color: #fff;
  background-color: #1a96d3;
}


.badge {
  padding: .45em .4em;
  min-width: 80px;
  margin: .4em;
}

.h1, h1 {
  font-size: 2.25rem;
}
.h2, h2 {
  font-size: 1.75rem;
}
.h3, h3 {
  font-size: 1.5rem;
}
.h4, h4 {
  font-size: 1.25rem;
}
.h5, h5 {
  font-size: 1.0rem;
}
.h6, h6 {
  font-size: 0.75rem;
}





</style>
